import { render } from "./Vendre.vue?vue&type=template&id=6ce25f4c&scoped=true"
import script from "./Vendre.vue?vue&type=script&lang=js"
export * from "./Vendre.vue?vue&type=script&lang=js"

import "./Vendre.vue?vue&type=style&index=0&id=6ce25f4c&lang=scss&scoped=true"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142257-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce25f4c"]])

export default __exports__